import React from "react";
import { connect } from "react-redux";
import NoticeBar from "../../pages/dashboard/components/noticeBar";

const MaintainanceModeBar = ({
  contractInfo,
  claimContractInfo,
  certContractInfo,
}) => {
  const contractMaintenanceMode =
    certContractInfo?.getIn(["setting", "maintenance_mode"]) ??
    claimContractInfo?.getIn(["setting", "maintenance_mode"]) ??
    contractInfo?.getIn(["setting", "maintenance_mode"]);

  return (
    <>
      {contractMaintenanceMode && (
        <NoticeBar
          type="help_desk_mode"
          details={
            <>
              This contract is currently under maintenance, please do not issue
              claim or certificate. Please contact{" "}
              <a
                className="external-link"
                href="https://support.asbuiltvault.com/request-paylab-support"
                rel="noreferrer"
                target="_blank"
              >
                <b>PayLab support</b>
              </a>{" "}
              for more information.
            </>
          }
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    contractInfo: state.getIn(["contract", "contractInfo"]),
    claimContractInfo: state.getIn(["makeaclaim", "contractInfo"]),
    certContractInfo: state.getIn(["makeacert", "contractInfo"]),
  };
};

export default connect(mapStateToProps, null)(MaintainanceModeBar);
